<app-spin-or-content [isSpin]="isLoading">
	@if (hasTemplateChoice) {
		<app-gen-select
			[options]="templates"
			(changeEvent)="handleTemplateChange($event)"
		/>
	}
	<h4>
		{{ "invite_texts" | langVal }}
		<app-icon
			icon="edit"
			titleLang="edit"
			pointer
			(click)="modalProps = { name: 'invite-texts' }"
		/>
	</h4>
	<div
		class="row"
		style="border: solid 1px var(--bs-green)"
	>
		<div class="row-12">
			<app-table-wrap fieldsStr="select,name">
				@for (row of inviteTexts; track row.id) {
					<tr>
						<td style="width: 100px">
							<app-check
								(onClick)="row.checked = !row.checked"
								[isCheck]="row.checked"
							/>
						</td>
						<td>
							{{ row.name }}
							{{ row.current_text }}
							@if (row.pending_text) {
								*
							}
						</td>
					</tr>
				}
			</app-table-wrap>
		</div>
	</div>
	@if (enablePolicyForms) {
		<h4>
			{{ "policy_forms" | langVal }}
			<app-icon
				icon="edit"
				titleLang="edit"
				pointer
				(click)="modalProps = { name: 'policy-forms-menu' }"
			/>
		</h4>
		<div class="row">
			<div class="row-12">
				<app-table-wrap fieldsStr="select,name">
					@for (row of policyFormVersions; track row.id) {
						<tr>
							<td style="width: 100px">
								<app-check
									(onClick)="row.checked = !row.checked"
									[isCheck]="row.checked"
								/>
							</td>
							<td>{{ row.name }}</td>
						</tr>
					}
				</app-table-wrap>
			</div>
		</div>
	}

	<h4>
		{{ "patient_details" | langVal }}
		<app-icon
			icon="edit"
			titleLang="edit"
			pointer
			(click)="modalProps = { name: 'patient-details-fields-manage' }"
		/>
	</h4>
	<div class="row">
		<div class="row-12">
			<app-check
				(onClick)="patientDetails = !patientDetails"
				[isCheck]="patientDetails"
			/>
		</div>
	</div>
	<h4>{{ "tests" | langVal }}</h4>
	<div class="row">
		<div class="row-12">
			<app-table-wrap fieldsStr="select,name,select,name">
				@for (row of tests; track row.id) {
					@if ($even) {
						<tr>
							<td style="width: 100px">
								<app-check
									(onClick)="row.checked = !row.checked"
									[isCheck]="row.checked"
								/>
							</td>
							<td>{{ row.name }}</td>
							@if (tests[$index + 1]) {
								<td style="width: 100px">
									<app-check
										(onClick)="
											tests[$index + 1].checked = !tests[$index + 1].checked
										"
										[isCheck]="tests[$index + 1].checked"
									/>
								</td>
								<td>{{ tests[$index + 1].name }}</td>
							}
						</tr>
					}
				}
			</app-table-wrap>
		</div>
	</div>
</app-spin-or-content>
<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	<app-btn-ext
		(clickEv)="closeChecked()"
		text="continue"
	/>
</div>
@switch (modalProps?.name) {
	@case ("policy-forms-menu") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="policy_forms"
		>
			<app-policy-forms-menu (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("invite-texts") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="invite_texts"
		>
			<app-invite-texts />
		</app-modal-wrap>
	}
	@case ("patient-details-fields-manage") {
		<app-modal-wrap (onClose)="modalProps = null">
			<app-patient-details-fields-manage (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
}
